import { Helper } from "../util/helper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";
export class TimePicker extends React.Component<TimePickerProps, any>{
    private _timePickerRef: any;
    private _timePicker: kendo.ui.TimePicker;
    private _value: any;
    private _disabled = true;

    componentWillUnmount() {
        this._timePicker.destroy();
    }

    componentDidMount() {
        this._disabled = this.props.disabled || false;
        this._value = this.props.value;
        this._timePicker = $(this._timePickerRef).kendoTimePicker({
            parseFormats: ['yyyy-MM-ddTHH:mm:ss', 'HH:mm'],
            value: this._value,
            change: (ev) => {
                this._value = ev.sender.value();
                this.props.onChange(this.props.field, Helper.dates.getISODateString(ev.sender.value()), null);
            }
        }).data("kendoTimePicker");
        this._timePicker.readonly(this._disabled);
        this._timePicker.wrapper.attr("data-readonly", this._disabled.toString());
        if (this.props.field.focus)
            this._timePicker.element.focus();
    }

    componentDidUpdate(prevProps, prevState) {
        const isDisabled = this.props.disabled || false;
        if (this._disabled !== isDisabled) {
            this._disabled = isDisabled;
            this._timePicker.readonly(this._disabled);
            this._timePicker.wrapper.attr("data-readonly", this._disabled.toString());
        }
        if (Helper.dates.compareMultiTypeDates(this._value, this.props.value, false) !== 0) {
            this._value = this.props.value;
            this._timePicker.value(this._value);
        }
    }

    render() {
        return (
            <div>
                <input ref={(r) => this._timePickerRef = r} name={this.props.field.model} style={{ width: "100%" }} required={this.props.required} data-label={this.props.field.name} />
            </div>
        );
    }
}
export interface TimePickerProps extends BaseComponentProps {
    field: TimePickerField;
}

interface TimePickerField extends BaseField {
    focus?: boolean;
}